import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IzbPartnerWithActionAuto = ({question,answer}) => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings_Banner.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 
  
  return (
    <>
      <Breadcrumb2
        Heading="Latest News"
        img={BackgroundBrundcrumb}
        show={true}
      
      />

        <section>
            <div className="container pt-5">
              <h1 className="pb-5 text-left">Indo Zambia Bank Partners with Action Auto Zambia to Extend Vehicle Financing Options</h1>
      
              <p className="pb-3">Indo Zambia Bank is pleased to announce a strategic partnership with Action Auto Zambia Limited, an authorized Isuzu vehicles dealer. This collaboration extends the Indo Vehicle Finance program to the general public, creating new opportunities for vehicle ownership across Zambia.</p>

              <h2 className="pt-4 pb-2"> Partnership Benefits</h2>
              <p className="pb-3">The partnership allows salaried individuals, businesses, partnerships, and sole proprietorships to access financing for both new and pre-owned vehicles through tailored financial solutions.</p>

            <p className="pb-3">"In line with our commitment to delivering accessible and tailored financial solutions, this partnership enables salaried individuals, businesses, partnerships, and sole proprietorships to acquire both brand-new and pre-owned vehicles with affordable financing options," said Indo Zambia Bank Managing Director, Brajesh Kumar Singh.</p>

            <h2 className="pt-4 pb-2">Key Features of Indo Vehicle Finance</h2>
            <ul>
                <li>👉  Low interest rates</li>
                <li>👉  Flexible repayment terms up to 72 months</li>
                <li>👉  Expedited approval process (72-hour turnaround with complete documentation)</li>
                <li>👉  Vehicle loan takeover options from other financial institutions</li>
                <li>👉  Reimbursement for vehicles purchased using personal funds</li>
              </ul>

              <h2 className="pt-4 pb-2">Industry Response</h2>
              <p className="pb-3">Action Auto Zambia's Managing Director, Michael Bentley, shared his enthusiasm for the initiative: "We are particularly excited to see the potential that this collaboration holds for our new customers. Whether it is personal mobility or business growth, this vehicle asset finance will make owning a brand-new Isuzu vehicle or truck more attainable than ever before."</p>

              <p className="pt-3">For more information call us on <a href="tel:0211226294">0211 226294</a> or email us at <a href="mailto:vaf@izb.co.zm">vaf@izb.co.zm</a> and apply for Indo Vehicle Finance today!</p>

              <h2 className="pt-4 pb-4">Gallery</h2>
            
              <div className="test news-slider-list-slider izb-partner-action row align-items-center">
                <Slider {...settings}>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-partners-with-action-1.jpg" alt="izb-partner-with-action-auto-gallery" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-partners-with-action-2.jpg" alt="izb-partner-with-action-auto-gallery" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-partners-with-action-3.jpg" alt="izb-partner-with-action-auto-gallery" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-partners-with-action-new-mod-4.jpg" alt="izb-partner-with-action-auto-gallery" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-partners-with-action-5.jpg" alt="izb-partner-with-action-auto-gallery" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-partners-with-action-6.jpg" alt="izb-partner-with-action-auto-gallery" />
                  </div>
                </Slider>
              </div>
            </div>

            

        </section>

      <CustomerCare />
      <OurStores />

    </>
  );
};

export default IzbPartnerWithActionAuto;